document.addEventListener('DOMContentLoaded', function () {
  function initializeAddToCartButtons() {
    document.querySelectorAll('.add-to-cart-button').forEach(function(button) {
      // Alte Event Listener entfernen, um Konflikte zu vermeiden
      button.removeEventListener('click', handleAddToCartClick);
      button.addEventListener('click', handleAddToCartClick);
    });
  }

  function handleAddToCartClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const variantId = button.getAttribute('data-id');
    button.classList.add('Button--loading'); // Ladeanimation starten

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(response => response.json())
    .then(data => {
      button.classList.remove('Button--loading'); // Ladeanimation stoppen
      updateCartDrawer(); // Aktualisiere den Cart Drawer
    })
    .catch(error => {
      console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
      button.classList.remove('Button--loading');
      alert("Es gab ein Problem beim Hinzufügen des Produkts zum Warenkorb.");
    });
  }

  function updateCartDrawer() {
    fetch('/cart?view=drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(html, 'text/html');
        const cartDrawer = document.querySelector('cart-drawer');

        // Aktualisiere den Inhalt des Cart Drawers
        cartDrawer.innerHTML = newDocument.querySelector('cart-drawer').innerHTML;
        cartDrawer.classList.add('active'); // Drawer anzeigen
        document.body.classList.add('overflow-hidden'); // Scrollen verhindern

        // Event Listener für neue Buttons im aktualisierten Drawer neu setzen
        initializeAddToCartButtons();
        initializeCloseCartDrawer();
      });
  }

  function closeCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  function detectClickOutsideDrawer(event) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer.contains(event.target) && cartDrawer.classList.contains('active')) {
      closeCartDrawer();
    }
  }

  function initializeCloseCartDrawer() {
    const cartDrawerOverlay = document.querySelector('#CartDrawer-Overlay');
    if (cartDrawerOverlay) {
      cartDrawerOverlay.removeEventListener('click', closeCartDrawer);
      cartDrawerOverlay.addEventListener('click', closeCartDrawer);
    }

    document.removeEventListener('click', detectClickOutsideDrawer);
    document.addEventListener('click', detectClickOutsideDrawer);
  }

  // Event Listener beim Laden der Seite initialisieren
  initializeAddToCartButtons();
  initializeCloseCartDrawer();
});


// Define a new custom element
class CartUpsells extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector('cart-drawer');
  }

  connectedCallback() {

    this.productNodes = this.querySelectorAll(".CartUpsellItem");
    console.log(this.productNodes);
    if (this.productNodes) {
      this.productNodes.forEach((item) => {
        const select = item.querySelector("select");
        select.addEventListener("change", () =>
          this.productVariantChanged(item)
        );

        const button = item.querySelector(".button");
        console.log(button);
        button.addEventListener("click", () => this.addToCart(button));
      });
    }
  }

  productVariantChanged = (productItem) => {
    console.log(productItem);
    let id = productItem.querySelector("select").value;
    console.log(id);
    this.changeAddToCartButton(id, productItem);
  };

  changeAddToCartButton(id, productItem) {
    productItem.querySelector(".button").setAttribute("data-id", id);
  }

  async addToCart(ButtonNode) {
    let id = ButtonNode.getAttribute("data-id");
    ButtonNode.classList.add("Button--loading");
    let postData = {};
    postData.items = [];
    
    let product = {};
    
    product.id = id;
    product.quantity = 1;
    postData.items.push(product);
    let url = window.Shopify.routes.root + "cart/add.js";


    var form_data = new FormData();

              form_data.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
    
    for ( var key in postData.items[0]) {
        form_data.append(key, postData.items[0][key]);
      console.log(key, postData.items[0][key]);
    }
    
    const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

    config.body = form_data;
    
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        return response.json();
      })
      .then((data) => {
        
        setTimeout(() => {
          this.cart.renderContents(data);
        });
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }
}

customElements.define("cart-upsells", CartUpsells);

